/** The course fields that say who may use TeachNow. */
export interface TeachNowCourseFeatures {
  /** Features students see. `teachnow` here lets students teach peers. */
  features?: readonly string[];
  /** Features SLs and mentors see. `teachnow` here lets them teach. */
  slFeatures?: readonly string[];
}

/**
 * Whether any role in the course can use TeachNow.
 *
 * A course can open TeachNow to SLs and mentors (`slFeatures`) before
 * students may teach (`features`). Backend jobs that keep rooms, nudges and
 * transcripts in order must run in either case, since the students being
 * helped are there either way.
 *
 * @param course - The course document.
 * @return True when `teachnow` is in either feature list.
 */
export function isTeachNowEnabledForAnyRole(
  course: TeachNowCourseFeatures | undefined,
): boolean {
  return Boolean(
    course?.features?.includes('teachnow') ||
      course?.slFeatures?.includes('teachnow'),
  );
}
